
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'office-ui-fabric-react/lib/Link';

import infoGetActions from '../../../sagas/info';
import { getToken } from '../../../reducers/auth';
import { getProjectKatuzeItems } from '../../../reducers/project';
import { getParName } from '../../../reducers/par';

const LinkToParcela = ({isknDate, par}) => {

    const dispatch = useDispatch();
    const infoActions = infoGetActions(dispatch);

    const token = useSelector(state => getToken(state.auth));
    const projectKatuzeItems = useSelector(state => getProjectKatuzeItems(state.project));

    const handleClick = () => {
        infoActions.getObjectParcela(
            token,
            projectKatuzeItems.map(item => item.kod),
            isknDate,
            par.par_id
        );
    }

    return (
        <Link onClick={handleClick} title="Zobrazit informace o parcele">{getParName(par)}</Link>
    )
}

export default LinkToParcela;
